module.exports = __webpack_public_path__ + "img/menu-hair-1.941d0733.webp";